(function() {

  function normalizeJSESize(value) {
    if (!value) return '';

    return value
      .toLowerCase()
      .replace(/cm/g, '')
      .replace(/×/g, 'x')
      .replace(/\s+/g, '')
      .trim();
  }


  function syncJSESelectedSize() {

    var checkedSize =
      document.querySelector(
        'variant-picker input[data-option-name="Taille"]:checked'
      ) ||
      document.querySelector(
        '.variant-picker input[data-option-name="Taille"]:checked'
      );


    if (!checkedSize) return;


    var currentSize =
      normalizeJSESize(checkedSize.value);


    document
      .querySelectorAll('.jse-size-card[data-jse-size]')
      .forEach(function(card) {

        var selected =
          card.dataset.jseSize === currentSize;


        card.classList.toggle(
          'is-selected',
          selected
        );

      });

  }



  /* Chargement initial */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      syncJSESelectedSize
    );

  } else {

    syncJSESelectedSize();

  }



  /* Changement de taille */

  document.addEventListener(
    'change',
    function(event) {

      var input = event.target.closest(
        'input[data-option-name="Taille"]'
      );


      if (!input) return;


      requestAnimationFrame(
        syncJSESelectedSize
      );


      setTimeout(
        syncJSESelectedSize,
        150
      );

    }
  );



  /* Shopify remplace le DOM du variant picker lors du re-rendu de section :
     on observe uniquement ce composant, pas toute la page, pour rester léger. */

  var syncScheduled = false;


  function scheduleJSESync() {

    if (syncScheduled) return;


    syncScheduled = true;


    requestAnimationFrame(function() {

      syncScheduled = false;

      syncJSESelectedSize();

    });

  }


  var jsePickers = document.querySelectorAll('variant-picker, .variant-picker');


  if (jsePickers.length) {

    var observer = new MutationObserver(scheduleJSESync);


    jsePickers.forEach(function(picker) {

      observer.observe(picker, { childList: true, subtree: true });

    });

  }



  /* Éditeur Shopify */

  document.addEventListener(
    'shopify:section:load',
    syncJSESelectedSize
  );

})();
